import produce from 'immer'

const initialState = {
  title: 'Plataforma',
  favicon: null,
  logo: null,
  logoWhite: null,
  color: '#1890ff',
  loading: false,
  error: null,
}

export default (state = initialState, { type, payload }) =>
  produce(state, draft => {
    const newDraft = draft

    switch (type) {
      case '@whiteLabel/REQUEST': {
        newDraft.error = null
        newDraft.loading = true
        break
      }
      case '@whiteLabel/SUCCESS': {
        newDraft.favicon = payload.data.favicon || initialState.favicon
        newDraft.logo = payload.data.logo || initialState.logo
        newDraft.logoWhite = payload.data.logo_white || initialState.logoWhite
        newDraft.color = payload.data.color || initialState.color
        newDraft.title = payload.data.title || initialState.title
        newDraft.loading = false
        break
      }
      case '@whiteLabel/FAILURE': {
        newDraft.error = payload.error
        newDraft.loading = false
        break
      }
      default:
    }
  })
